import React from 'react';
import { Navigate, Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { LayoutDashboard, LogOut, Package, Mail, Boxes } from 'lucide-react';
import { Logo } from '../../Logo';
export function AdminLayout() {
  const {
    user,
    profile,
    loading,
    signOut
  } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen bg-[#F9F9F9] flex items-center justify-center" data-id="element-278" data-mp="3imvm6gww5u22">
        <span className="w-6 h-6 border-2 border-tealslate/30 border-t-tealslate rounded-full animate-spin" data-id="element-279" data-mp="3doaked1zr2bi" />
      </div>;
  }
  if (!user || profile?.role !== 'admin') {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-280" data-mp="3rlqrlqs4304b" />;
  }
  return <div className="min-h-screen bg-[#F9F9F9] flex" data-id="element-281" data-mp="1x9ity5oeo54u">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-[#E5E5E5] flex flex-col" data-id="element-282" data-mp="1t8grzh33tez6">
        <div className="p-6 border-b border-[#E5E5E5]" data-id="element-283" data-mp="1tajmoef7bwa8">
          <Link to="/admin" className="flex items-center gap-3" data-id="element-284" data-mp="205zhd03963yu">
            <Logo className="w-8 h-8" data-id="element-285" data-mp="253rkyrd9feiv" />
            <span className="font-bold text-[#111111] tracking-tight" data-id="element-286" data-mp="254syr3lnuf4a">
              Admin
            </span>
          </Link>
        </div>
        <nav className="flex-1 p-4 space-y-1" data-id="element-287" data-mp="2a1awvkmhjf7n">
          <Link to="/admin" className={`flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors ${location.pathname === '/admin' ? 'bg-[#F0F4F8] text-tealslate' : 'text-[#5A5A5A] hover:bg-[#F9F9F9] hover:text-[#111111]'}`} data-id="element-288" data-mp="2euvyrnr78tc4">
            <LayoutDashboard className="w-5 h-5" data-id="element-289" data-mp="2stc53dl5ghtq" />
            Dashboard
          </Link>
          <Link to="/admin/orders" className={`flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors ${location.pathname.startsWith('/admin/orders') ? 'bg-[#F0F4F8] text-tealslate' : 'text-[#5A5A5A] hover:bg-[#F9F9F9] hover:text-[#111111]'}`} data-id="element-290" data-mp="2xt89vf1o8dac">
            <Package className="w-5 h-5" data-id="element-291" data-mp="vd7sdub1fo77" />
            Orders
          </Link>
          <Link to="/admin/products" className={`flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors ${location.pathname.startsWith('/admin/products') ? 'bg-[#F0F4F8] text-tealslate' : 'text-[#5A5A5A] hover:bg-[#F9F9F9] hover:text-[#111111]'}`} data-id="element-292" data-mp="rcnvmrudmmll">
            <Boxes className="w-5 h-5" data-id="element-293" data-mp="1ecbxirzgkxtl" />
            Products
          </Link>
          <Link to="/admin/newsletter" className={`flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors ${location.pathname.startsWith('/admin/newsletter') ? 'bg-[#F0F4F8] text-tealslate' : 'text-[#5A5A5A] hover:bg-[#F9F9F9] hover:text-[#111111]'}`} data-id="element-294" data-mp="1ab8ksecpjhwl">
            <Mail className="w-5 h-5" data-id="element-295" data-mp="1y0bam9hhwh26" />
            Newsletter
          </Link>
        </nav>
        <div className="p-4 border-t border-[#E5E5E5]" data-id="element-296" data-mp="1t202q4arggml">
          <button onClick={() => signOut()} className="flex items-center gap-3 px-4 py-3 w-full rounded-md text-sm font-medium text-[#5A5A5A] hover:bg-[#F9F9F9] hover:text-[#111111] transition-colors" data-id="element-297" data-mp="1t3kwvst5xxjx">
            <LogOut className="w-5 h-5" data-id="element-298" data-mp="22pm475ng9nui" />
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto" data-id="element-299" data-mp="27ndxa2ztzg0a">
        <Outlet data-id="element-300" data-mp="27q9vlsflc6p9" />
      </main>
    </div>;
}